export const isFirefox = () => {
  return (window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1);
}